import Image from 'tiptap-extension-resize-image';

const keepImageFocused = ({ editor, transaction }) => {
  const steps = transaction.steps;
  const oneMutation = steps.length === 1;
  const changedNode = steps[0]?.slice?.content?.content?.[0];

  if (!(oneMutation && changedNode && changedNode.type.name === 'image')) {
    return;
  }

  editor.state.doc.descendants((node, pos) => {
    changedNode === node && editor.commands.setNodeSelection(pos);
  });

  requestAnimationFrame(() => {
    editor.view.dom.querySelector('.ProseMirror-selectednode img').click();
  });
};

// TODO: [Ricardo] Upload these images instead of storing a base64 representation
const imageConfiguration = {
  inline: true,
  allowBase64: true,
};

const ImageExtension = Image.extend({ onSelectionUpdate: keepImageFocused });

const imageExtensions = [ImageExtension.configure(imageConfiguration)];

export default imageExtensions;
